import request from "../../utiles/axios";

/**
 * 查询农户列表
 * @param {*} data
 * @returns
 */
export function getFarmerPage(data) {
  return request({
    url: "/farmer/PcPage",
    method: "post",
    data: data,
  });
}
/**
 * 查询标的列表
 * @param {*} data
 * @returns
 */
export function getTargetPage(data) {
  return request({
    url: "/target/pcPage",
    method: "post",
    data: data,
  });
}
/**
 * 查询机构树
 * @param {*} data
 * @returns
 */
export function getDeptTree(data) {
  return request({
    url: "/dept/deptTree",
    method: "post",
    data: data,
  });
}
/**
 * 照片下载
 * @param {*} data
 * @returns
 */
export function downLoadZip(data) {
  return request({
    url: "/farmer/downLoadZip",
    responseType:'blob',
    method: "post",
    data: data,
  });
}
/**
 * 标的批次列表
 * @returns
 */
export function getSubjectBatchList() {
  return request({
    url: "/subjectBatch/list",
    method: "get",
  });
}
/**
 * 标的详情
 * @param {*} id
 * @returns
 */
export function appTargetDetail(id) {
  return request({
    url: `/target/appTargetDetail?targetInfoId=${id}`,
    method: "get",
  });
}

/**
 * 完成审核
 * @param {*} data
 * @returns
 */
export function targetAudit(data) {
  return request({
    url: `/target/targetAudit`,
    method: "post",
    data
  });
}
/**
 * 查询重新对比验标是否完成
 */
export function targetCompleted(data) {
  return request({
    url: `/target/allTargetCompleted`,
    method: "post",
    data,
  });
}
/**
 * 完成审核
 * @param {*} data
 * @returns
 */
export function completionAudit(id) {
  return request({
    url: `/pc/order/completionAudit?id=${id}`,
    method: "post",
  });
}

export function getAccessAly() {
  return request({
    url: `/common/getAccessAly`,
    method: "get",
  });
}

export function getConcerteduserList(orderId) {
  return request({
    url: `/pc/order/getConcertedUser/${orderId}`,
    method: "get",
  });
}

export function saveTarget(data) {
  return request({
    url: `target/save`,
    method: "post",
    data
  });
}

// 新建农户
export function saveFarmer(data) {
  return request({
    url: `/farmer/save`,
    method: "post",
    data
  });
}

/**
 * 重新对比验标
 * @param {} data 
 * @returns 
 */
export function reCompares(data) {
  return request({
    url: `/target/rebuildTargetList`,
    method: "post",
    data
  });
}

  /**
   * 查询租户配置
   */
  export function getCompanyOption(compCode) {
    return request({
      // url: "/companyOption/getCompanyOption?compCode=" + compCode ,
      url: `/companyOption/getCompanyOption/${compCode}`,
      method: "get",
    });
  }

  /**
 * 查询团体列表
 * @param {*} data
 * @returns
 */
export function groupInfoSelect(params) {
  return request({
    url: "/groupInfo/select",
    method: "get",
    params: params,
  });
}

/**
 * 获取腾讯云配置
 */
export  function getTencentCloudConfig() {
  return request({
    url: "/common/getTencentCloudConfig",
    method: "get",
  });
}

/**
 * 取消异常上报
 * @param {string} id 异常上报ID
 * @returns {Promise}
 */
export function cancelExceptionReport(id) {
  return request({
    url: `/exceptionReport/cancel/${id}`,
    method: "get",
  });
}


/**
 * 获取机构校验配置
 * @param {*} orderId
 * @returns
 */
export function getVerifyEnumByOrder(orderId) {
  return request({
    url: `/pc/order/getVerifyEnumByOrderId/${orderId}`,
    method: "get",
  });
}